import { getProductPreview } from '@/app/utils/assignedProductHelper';

const checkIsProductPage = (pageType: string) => {
  return pageType === 'template-product';
};

export function getProductOption(isProductPage: boolean): object {
  if (!isProductPage) {
    return {
      'manual-select': 'Select manually',
    };
  } else {
    return {
      'assigned-products': 'Display by assigned product',
      'manual-select': 'Select manually',
    };
  }
}

const updateProductSettings = (params: any) => {
  const { productPosition, pTypeDefault, pIdValue, pageType } = params;
  const { item } = productPosition;

  const assign = Object.assign({}, item);
  const isProductPage = checkIsProductPage(pageType);
  const options = getProductOption(isProductPage);

  assign.type = 'group';
  assign.caption = 'Select Product';
  assign.items = [
    {
      name: 'product-data',
      id: 'assign-product-data',
      caption: '',
      type: 'select',
      options: options,
      default_value: pTypeDefault,
    },
    {
      name: 'product',
      id: 'assigned-product',
      caption: 'Product',
      type: 'text',
      readonly: 'true',
      default_value: '',
      requires: 'assign-product-data|assigned-products',
    },
    {
      name: 'product',
      id: 'assign-select-product',
      caption: 'Product',
      type: 'text',
      readonly: 'true',
      default_value: '',
      default_value_image: '',
      default_value_id: pIdValue,
      requires: 'assign-product-data|manual-select',
    },
  ];

  return assign;
};

export const upgradeProductSettingAssign = (fields: any, pageType: string) => {
  const assignFields = [...fields];
  const productPosition: any = { index: -1, item: {} };
  const fieldLength = assignFields.length;
  let isEnabledDynamic = false;
  let pIdValue = '';
  let pTypeDefault = 'manual-select';
  let indexPId: any = undefined;

  for (let i = 0; i < fieldLength; i++) {
    const item = assignFields[i];

    const itemId = item.id;
    const itemDefaultValue = item.default_value;
    const itemClass = item.class;

    // Hide this text: (If you want to show the product linked with the product page you are viewing, make sure to enable Dynamic option)
    if (itemClass === 'ui-dform-span set_des') {
      assignFields[i].visible = 'field-hide-all';
    }

    if (itemId === 'product') {
      // Nhớ vị trí của Product config
      productPosition.index = i;
      productPosition.item = item;

      // Ẩn text mô tả của product đi
      assignFields[i].desc = '';
      assignFields[i].default_value = assignFields[i].default_value || '';
    }

    if (itemId === 'dynamic') {
      // Ẩn trường dynamic (Vì product kiểu mới sẽ không có trường dynamic)
      assignFields[i].visible = 'field-hide-all';
      // Lấy giá trị của trường dynamic để update vào select của Assign product
      if (itemDefaultValue === '1') {
        // Is on
        isEnabledDynamic = true;
      }
    }

    if (itemId === 'pid') {
      pIdValue = itemDefaultValue;
      indexPId = i;
    }
  } // End for loop

  if (!indexPId === undefined) {
    console.error('product have no pid');
    return;
  }

  // Nếu dynamic được bật ở module này sẽ update select để tự động select giá trị đầu tiên là Assigned product
  if (isEnabledDynamic && pageType == 'template-product') {
    pTypeDefault = 'assigned-products';
  }

  // Assigned product: Trường hợp load lần đầu => sẽ load theo picked preview product
  if (pTypeDefault === 'assigned-products' && isEnabledDynamic) {
    const tempId = getPreviewIdForDynamic(pIdValue);
    if (tempId !== pIdValue) {
      pIdValue = tempId;
    }
  }

  // Manual select: Trường hợp load lần đầu => manual select cũ và kiểu là auto
  // if (pTypeDefault === 'manual-select' && pIdValue === 'auto') {
  //   const productLatest: any = HELPER.searchProductInList('auto');
  //   if (productLatest) {
  //     pIdValue = productLatest.id;
  //   } else {
  //     console.info('have no latest product');
  //   }
  //   console.log('set latest id to manual now:', productLatest);
  // }

  const { index } = productPosition;
  const params = { productPosition, pTypeDefault, pIdValue, pageType };
  assignFields[index] = updateProductSettings(params);

  // Update pId
  assignFields[indexPId].default_value = pIdValue;

  return assignFields;
};

// Kểm tra xem khách có đang selected product nào để preview không,
// Nếu có thì trả về product id đó
const getPreviewIdForDynamic = (pIdValue: string) => {
  // Nếu dynamic được bật thì tự convert pId thành auto
  if (pIdValue != 'auto') {
    return 'auto';
  }
  // Lấy productId đang được picked để preview
  const previewId = getProductPreview();
  if (previewId !== 'auto') {
    return previewId;
  }
  return 'auto';
};
